import * as React from "react";
import { UseDownloadAsset } from "../../../../api/calls/Queries";
import { EscapeRoomQuestion, TourData, question } from "../../../../Types";
import { useSetAnswer } from "../../../../api/calls/Quiz";
import { getLanguageFile } from "../../../common/GetLanguageFile";
import { useViewerPopupStore } from "../../../../state management/zustand/viewer-stores";
import {
  useEscapeRoomDataStore,
  useMockEscapeRoomStore,
} from "../../escape-room/zustand";
import { useCurrentSceneStore } from "../../../../api/Zustand";

function QuizPopup(props: {
  tourID: number;
  userID: number;
  tourData: TourData;
}) {
  const [selectedAnswers, setSelectedAnswers] = React.useState<number[]>([]);

  const { currentPopupContent, isOpen, setClose } = useViewerPopupStore();

  const currentPop = currentPopupContent as question;

  const { tourID, userID, tourData } = props;

  const {
    mutateAsync: setAnswer,
    isPending,
    isError,
  } = useSetAnswer(tourID, tourData.assignedQuizID!, userID);

  const [isConfirmed, setIsConfirmed] = React.useState<boolean>(false);
  const { data: imageBlob, isLoading: isLoadingImage } = UseDownloadAsset(
    currentPop?.questionImgKey
  );

  const selectAnsw = (id: number) => {
    if (currentPop.questionTypeId === 2) {
      if (selectedAnswers.find((one) => one === id)) {
        let temp = selectedAnswers.filter((values) => values !== id);

        setSelectedAnswers(temp);
      } else {
        let tempP = [...selectedAnswers];
        tempP.push(id);
        setSelectedAnswers(tempP);
      }
    } else {
      let tempS = [id];

      setSelectedAnswers(tempS);
    }
  };

  const questionIndex = React.useMemo(() => {
    const quizdata = tourData.quizData?.data;

    let index = quizdata?.findIndex(
      (question) => question.questionId === currentPop?.questionId
    );

    return index ?? 0;
  }, [currentPop, tourData.quizData?.data]);

  const [showingResult, setShowingResult] = React.useState<boolean | undefined>(
    undefined
  );

  const escapeRoomQuestion = React.useMemo(() => {
    const { questionId } = currentPopupContent as question;

    const question = tourData.escapeRoomData?.escapeRoomQuestions?.find(
      (one) => one.questionID === questionId
    );
    return question;
  }, [currentPopupContent, tourData.escapeRoomData]);

  const { removeQuestion, setAnswered, answeredQuestions } =
    useMockEscapeRoomStore();

  const hasBeenAnswered = React.useMemo(() => {
    return answeredQuestions.includes(currentPop.questionId);
  }, [answeredQuestions, currentPop.questionId]);

  // React.useEffect(() => {
  //   if (beenAnswered.answered) {
  //     removeQuestion(currentPop.questionId);
  //   }
  // }, [beenAnswered, currentPop.questionId, removeQuestion]);

  return (
    <div
      className={`popup-panel quiz ${isOpen ? "open" : "closed"}`}
      id={isOpen ? "open" : "closed"}
      style={{
        padding: 0,
      }}
    >
      <div className="question-index">{questionIndex + 1}</div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        {imageBlob && (
          <img
            src={imageBlob}
            alt="Immagine della domanda"
            loading="lazy"
            style={{
              maxWidth: 700,
              maxHeight: 400,
            }}
          />
        )}
      </div>
      <div
        style={{
          padding: "2rem",
        }}
      >
        <div
          style={{
            fontSize: "1rem",
            marginBottom: "1rem",
          }}
        >
          {currentPop?.questionText}
        </div>

        {showingResult === undefined && (
          <div>
            {hasBeenAnswered && <i>{getLanguageFile("viewer.already_ans")}</i>}

            <br></br>

            {!hasBeenAnswered && currentPop.questionTypeId === 2 ? (
              <i>{getLanguageFile("right_panel.multi_ans")}</i>
            ) : null}
            <div className="answers-wrapper">
              {currentPop?.answers &&
                currentPop.answers.map((ans: any) => (
                  <button
                    // disabled={hasBeenAnswered}
                    key={ans.answerId}
                    className="answer"
                    onClick={() => selectAnsw(ans.answerId)}
                    id={
                      selectedAnswers?.find((one) => one === ans.answerId)
                        ? "selected"
                        : undefined
                    }
                  >
                    <p>{ans.answerText}</p>
                  </button>
                ))}
            </div>
          </div>
        )}
        {showingResult === true && (
          <AnsweredCorrectly escapeRoomQuestion={escapeRoomQuestion} />
        )}
        {showingResult === false && (
          <AnsweredWrongly escapeRoomQuestion={escapeRoomQuestion} />
        )}

        {isError && (
          <p
            style={{
              padding: 10,
              textAlign: "center",
              opacity: 0.8,
            }}
          >
            <i>{getLanguageFile("quiz.answer_error")}</i>
          </p>
        )}
        <div
          style={{
            display: "flex",
          }}
        >
          {!isConfirmed && showingResult === undefined && (
            <button
              className="answer confirm"
              style={{ flex: 1 }}
              disabled={
                isPending || isConfirmed || selectedAnswers?.length === 0
              }
              onClick={() =>
                setAnswer(
                  {
                    questionId: currentPop.questionId,
                    answerIds: selectedAnswers!,
                  },
                  {
                    onSuccess: (data: {
                      success: boolean;
                      answerIsCorrect: boolean;
                    }) => {
                      setSelectedAnswers([]);

                      if (data.success) {
                        setAnswered(
                          currentPop.questionId,
                          data.answerIsCorrect
                        );

                        setClose();

                        // setShowingResult(data.answerIsCorrect);

                        removeQuestion(currentPop.questionId);
                      }

                      // setBeenAnswered({
                      //   answered: data.success,
                      //   correct: data.answerIsCorrect,
                      // });
                    },
                  }
                )
              }
            >
              {isPending
                ? getLanguageFile("generics.loading")
                : isConfirmed
                ? getLanguageFile("quiz.answer_confirmed")
                : getLanguageFile("quiz.confirm")}
            </button>
          )}
          <button
            style={{ flex: 1 }}
            onClick={() => {
              setClose();
              setIsConfirmed(false);

              setSelectedAnswers([]);
            }}
            className="answer confirm"
            disabled={isPending}
          >
            {showingResult === undefined
              ? getLanguageFile("quiz.cancel")
              : getLanguageFile("generics.close")}
          </button>
        </div>
      </div>
    </div>
  );
}

function romanize(num: number) {
  let lookup = {
      M: 1000,
      CM: 900,
      D: 500,
      CD: 400,
      C: 100,
      XC: 90,
      L: 50,
      XL: 40,
      X: 10,
      IX: 9,
      V: 5,
      IV: 4,
      I: 1,
    },
    roman = "",
    i;
  for (i in lookup) {
    //@ts-ignore
    while (num >= lookup[i]) {
      roman += i;
      // @ts-expect-error
      num -= lookup[i];
    }
  }
  return roman;
}

export default QuizPopup;

const AnsweredCorrectly = (props: {
  escapeRoomQuestion: EscapeRoomQuestion | undefined;
}) => {
  const { setClose } = useViewerPopupStore();

  const { type, started, ended, addPoints, addSecondToTimer } =
    useEscapeRoomDataStore();

  const { setOpen } = useViewerPopupStore();
  const escapeRoomIsRunning = started && !ended;

  const { setCurrentSceneID } = useCurrentSceneStore();

  const actionToPerform = React.useCallback(() => {
    if (type === 1) {
      addSecondToTimer(props.escapeRoomQuestion?.value!);
    } else if (type === 2 && props.escapeRoomQuestion?.value) {
      addPoints(props.escapeRoomQuestion?.value);
    }
    if (props.escapeRoomQuestion?.correctAnsPopID) {
      setOpen(props.escapeRoomQuestion.correctAnsPopID);
    } else if (props.escapeRoomQuestion?.correctAnsSceneID) {
      setCurrentSceneID(props.escapeRoomQuestion.correctAnsSceneID);
    }
  }, [
    addSecondToTimer,
    props.escapeRoomQuestion,
    setCurrentSceneID,
    setOpen,
    type,
    addPoints,
  ]);

  React.useEffect(() => {
    if (escapeRoomIsRunning) {
      actionToPerform();
    } else {
      const timeout = setTimeout(() => {
        setClose();
      }, 5e3);

      return () => clearTimeout(timeout);
    }
  }, [setClose, escapeRoomIsRunning, actionToPerform]);

  return (
    <div className="answer-response">
      {getLanguageFile("viewer.correct_ans")}
    </div>
  );
};

const AnsweredWrongly = (props: {
  escapeRoomQuestion: EscapeRoomQuestion | undefined;
}) => {
  const { setClose } = useViewerPopupStore();

  const { started, ended, type, addPoints, addSecondToTimer, reduceLives } =
    useEscapeRoomDataStore();
  const escapeRoomIsRunning = started && !ended;
  const { setOpen } = useViewerPopupStore();

  const { setCurrentSceneID } = useCurrentSceneStore();

  const actionToPerform = React.useCallback(() => {
    if (type === 1) {
      addSecondToTimer(-5);
    } else if (type === 2 && props.escapeRoomQuestion?.value) {
      addPoints(props.escapeRoomQuestion.value * -1);
    } else if (type === 3) {
      reduceLives();
    }

    if (props.escapeRoomQuestion?.wrongAnsPopID) {
      setOpen(props.escapeRoomQuestion.wrongAnsPopID);
    } else if (props.escapeRoomQuestion?.wrongAnsSceneID) {
      setCurrentSceneID(props.escapeRoomQuestion.wrongAnsSceneID);
    }
  }, [
    addSecondToTimer,
    props.escapeRoomQuestion,
    setCurrentSceneID,
    setOpen,
    type,
    reduceLives,
    addPoints,
  ]);

  React.useEffect(() => {
    if (escapeRoomIsRunning) {
      actionToPerform();
    } else {
      const timeout = setTimeout(() => {
        // props.setPopOpen(false);

        setClose();
      }, 5e3);

      return () => clearTimeout(timeout);
    }
  }, [setClose, escapeRoomIsRunning, actionToPerform]);

  return (
    <div className="answer-response">{getLanguageFile("viewer.wrong_ans")}</div>
  );
};
